export default __webpack_public_path__ + "static/media/sidePics.a755eb9f.jpg";